import { ColDef } from '@ag-grid-community/core';
import { useRef } from 'react';

/**
 * @deprecated
 * DO NOT ADD TO THIS. See EN-81488
 *
 * This is a workaround to prevent an agGrid bug.
 *
 * When pivotMode changes from true to false,
 * AND the agColumns array changes in the same update,
 * the columns in the tool panel will disappear.
 *
 * This simply remembers the previous agColumns,
 * and forces them not to change specifically when pivotMode turns off.
 */
export const usePivotModeBugFixHack = (agColumns: ColDef[], pivotMode: boolean) => {
  const prevPivotModeRef = useRef(false);
  const prevAgColumnsRef = useRef<ColDef[]>([]);

  let finalAgColumns = agColumns;

  if (prevPivotModeRef.current === true && pivotMode === false) {
    finalAgColumns = prevAgColumnsRef.current;
  }

  prevAgColumnsRef.current = agColumns;
  prevPivotModeRef.current = pivotMode;

  return finalAgColumns;
};
